// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"893d7f64","239":"e6f47584","453":"663682cf","455":"94eea9bf"}[chunkId] + ".chunk.js";
};